import { connect } from 'react-redux';
import {
  compose, renderComponent, branch, renderNothing, withHandlers,
} from 'recompose';
import { withRouter } from 'react-router';

import StripeCheckoutButton from '../components/StripeCheckoutButton';
import CheckoutButton from './CheckoutButton';
import { getNoExtrasForReserveNoPay } from '../../shops/selectors';
import WithShopCurrency from '../../hoc/WithShopCurrency';
import analytics from '../../applicationServices/analytics/BookingAnalytics';

const AnalyticsAwareStripeCheckoutButton = withHandlers({
  onSuccess: props => (...args) => {
    analytics.showStripeModal();

    return props.onSuccess(...args);
  },
})(StripeCheckoutButton);

export const withNewCheckoutButton = compose(
  withRouter,
  WithShopCurrency,
  branch(
    props => !props.currency,
    renderNothing,
  ),
  connect(
    (state, ownProps) => ({
      noExtrasForBookNoPay: getNoExtrasForReserveNoPay(state, ownProps.params.shopRoute),
    }),
  ),
  branch(
    props => !props.noExtrasForBookNoPay,
    renderComponent(AnalyticsAwareStripeCheckoutButton),
  ),
);

export default withNewCheckoutButton(CheckoutButton);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/withNewCheckoutButton.js